import { render, staticRenderFns } from "./SetupView.vue?vue&type=template&id=49def7e7&scoped=true&"
import script from "./SetupView.vue?vue&type=script&setup=true&lang=js&"
export * from "./SetupView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SetupView.vue?vue&type=style&index=0&id=49def7e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49def7e7",
  null
  
)

export default component.exports